"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is DocumentFragment
 * @param obj The object to check
 */
function isDocumentFragment(obj) {
    return safeInstanceOf_1.default(obj, 'DocumentFragment');
}
exports.default = isDocumentFragment;
//# sourceMappingURL=isDocumentFragment.js.map